module.exports = __webpack_public_path__ + "img/bg-dark.c352e143.png";